import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import "./index.css";
// import Post from "./components/Post/Post";
import PostList from "./containers/PostList/PostList.js";
import PostDetail from "./containers/PostDetail/PostDetail.js";
import reportWebVitals from "./reportWebVitals";
import Cookies from "universal-cookie";
import AdminPostList from "./admin/AdminPostList";
import AdminPostCreate from "./admin/AdminPostCreate";
import AdminPostUpdate from "./admin/AdminPostUpdate";
import LogoutPage from "./admin/LogoutPage";
import Login from "./admin/LoginPage";

const cookies = new Cookies();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 30000,
    },
  },
});

function initParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const userId = urlParams.get("user_id");
  const at = urlParams.get("at");
  if (userId) {
    localStorage.setItem("user_id", userId);
    window.location = 'https://feed.impactapp.in/post';
    console.log('viki');
  }
  if (at) {
    localStorage.setItem("at", at);
  }
}
initParams();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <div className="max-w-screen-sm mx-auto">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/post" />} />
            <Route path="/post" element={<PostList />} />
            <Route path="post/:id" element={<PostDetail />} />
            <Route path="post/:id/:post_title" element={<PostDetail />} />
            <Route
              exact
              path="/admin"
              element={
                cookies.get("authorization") ? (
                  <Navigate to="/admin/posts" />
                ) : (
                  <Login />
                )
              }
            />
            <Route exact path="/admin/posts" element={<AdminPostList />} />
            <Route
              exact
              path="/admin/posts/create"
              element={<AdminPostCreate />}
            />
            <Route
              exact
              path="/admin/posts/:post_id/edit"
              element={<AdminPostUpdate />}
            />
            <Route exact path="/logout" element={<LogoutPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
